/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/

/**
 * Returns a CSS class name based on the provided status.
 *
 * @param status - The status string which can be "Success", "In Progress", or any other value.
 * @returns The corresponding CSS class name: "success" for "Success", "in-progress" for "In Progress",
 *          and an empty string for any other status.
 */
const statusClassMap: { [key: string]: string } = {
  Success: "success",
  "In Progress": "in-progress",
  Failed: "failed"
  // Add more classes here
};

export const getStatusClass = (status: string): string => statusClassMap[status] || "";